import { AbortableSubmitEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';

import './vital-sign-pain-scale-field-controller.css'
import { Endpoint } from '../../../constants/endpoints';
import { FragmentNames, VitalSignPainScaleFieldAliases } from '../../../codegen';

interface ContextDataProps {
  data: {
    setPainScaleValue: (value: number) => void;
  }
}

enum PAIN_SCALE {
  PAINLESS = '0',
  WEAK = '2.5',
  MODERATE = '5',
  INTENSE = '7.5',
  UNBEARABLE = '10',
}

@Controller({ fragment: FragmentNames.VITAL_SIGN_PAIN_SCALE_FIELD })
class VitalSignPainScaleFieldController extends BaseController {

  @Inject(VitalSignPainScaleFieldAliases.PAIN_SCALE_FIELD_PANEL_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @OnMount({target: VitalSignPainScaleFieldAliases.VITAL_SIGN_PAIN_SCALE_FIELD_RADIO_GROUP})
  onMountRadioGroup(event: MountEvent): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const expressionId = 335977;

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          const radioGroup = event.target as RadioGroupAPI;
          const items = responseBody.map(item => ({
            ...item,
            value: String(Object.values(PAIN_SCALE)[Number(item.key)]),
          }))

          radioGroup.setData(items);
        }
      });
  }

  closeModalPainScale(): void {
    ModalService.close(FragmentNames.VITAL_SIGN_PAIN_SCALE_FIELD);
  }

  @OnClose({target: VitalSignPainScaleFieldAliases.MODAL_PAIN_SCALE_REFERENCE})
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({target: VitalSignPainScaleFieldAliases.VITAL_SIGN_PAIN_SCALE_FIELD_REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({target: VitalSignPainScaleFieldAliases.VITAL_SIGN_PAIN_SCALE_FIELD_RADIO_FORM})
  onClickCancel(): void {
    this.closeModalPainScale();
  }

  @OnBeforeSubmit({target: VitalSignPainScaleFieldAliases.VITAL_SIGN_PAIN_SCALE_FIELD_RADIO_FORM})
  onBeforeSubmitForm(event: AbortableSubmitEvent): void {
    const { data:  { setPainScaleValue }} = this.context as unknown as ContextDataProps;
    setPainScaleValue(event.record.key.value);

    ModalService.close(FragmentNames.VITAL_SIGN_PAIN_SCALE_FIELD);
  }
}
export default VitalSignPainScaleFieldController;
